export  function ParseNumber(value) {
  if (value == null) return 0; // null or undefined
  if (typeof value === 'number') return value;

  let s = String(value).trim();
  if (s === '') return 0;

  // convert localized digits (Arabic-Indic)
  s = replaceArabicIndicDigits(s);

  // remove non-breaking spaces and common whitespace
  s = s.replace(/\u00A0/g, '').replace(/\s+/g, '');

  // If both dot and comma exist, assume dot is thousands sep and comma is decimal (e.g. "1.234,56")
  if (s.includes('.') && s.includes(',')) {
    s = s.replace(/\./g, '').replace(/,/g, '.');
  } else {
    // remove commas used as thousands separators (e.g. "1,234")
    s = s.replace(/,/g, '');
  }

  // Remove any non-digit except minus sign and dot
  s = s.replace(/[^0-9.-]/g, '');

  const num = Number(s);
  return Number.isFinite(num) ? num : 0;
}

function replaceArabicIndicDigits(str) {
  if (typeof str !== 'string') return str;
  // Arabic-Indic (U+0660 - U+0669) and Extended Arabic-Indic (U+06F0 - U+06F9)
  const map = {
    '\u0660': '0','\u0661':'1','\u0662':'2','\u0663':'3','\u0664':'4','\u0665':'5','\u0666':'6','\u0667':'7','\u0668':'8','\u0669':'9',
    '\u06F0':'0','\u06F1':'1','\u06F2':'2','\u06F3':'3','\u06F4':'4','\u06F5':'5','\u06F6':'6','\u06F7':'7','\u06F8':'8','\u06F9':'9'
  };
  return str.replace(/[٠-٩۰-۹]/g, (d) => map[d] ?? d);
}